import { useTranslation } from 'react-i18next';
import {
    NavigationSearchCompany,
    NavigationSearchSite,
} from 'types/Navigation';
import { getIdFromItem } from './helpers';
import { SearchDropdownLink } from './SearchDropdownLink';

export type ResultsType = 'recent' | 'sites' | 'companies';

interface SearchDropdownResultsProps {
    type: ResultsType;
    data: NavigationSearchCompany[] | NavigationSearchSite[];
    loading?: boolean;
    selectedIndex?: number;
    onSelected?: () => void;
}

export const SearchDropdownResults = ({
    type,
    data,
    loading = false,
    selectedIndex,
    onSelected = () => {},
}: SearchDropdownResultsProps) => {
    const { t } = useTranslation('layout', { keyPrefix: 'search-bar' });
    const { t: commonT } = useTranslation('common');

    return (
        <div className="px-2">
            <h3 className="text-secondary font-bold bg-white sticky text-base top-0 h-8 py-2 flex items-center">
                {t(type)}
            </h3>

            {loading && (
                <div
                    aria-label={commonT('loading')}
                    className="flex flex-col gap-2"
                >
                    <div className="h-6 rounded-sm bg-gray-100 animate-pulse" />
                    <div className="h-6 rounded-sm bg-gray-100 animate-pulse" />
                    <div className="h-6 rounded-sm bg-gray-100 animate-pulse" />
                </div>
            )}

            {!loading && data.length === 0 && (
                <div className="text-center p-4">
                    {t(`no-results-found.${type}`)}
                </div>
            )}

            {!loading && data.length > 0 && (
                <div>
                    {data.map((item, index) => (
                        <SearchDropdownLink
                            key={`${type}-${getIdFromItem(type, item)}`}
                            item={item}
                            type={type}
                            index={index}
                            selectedIndex={selectedIndex}
                            onSelected={onSelected}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
